<script>
  import { onMount } from 'svelte';

  import { HeaderSearch } from 'carbon-components-svelte';

  import SearchBarOutputWrapper from './SearchBarOutputWrapper.svelte';

  import { getGroups, getOrganizations, getAllUsers } from '../../services';
  import { searchStore, updateKeys } from '../../stores';
  import { rowContainsText } from '../../utils';

  let searchRef;

  const checkCloseClick = (e) => {
    if (!$searchStore.overlayHidden && !searchRef.contains(e.target)) {
      updateKeys({ overlayHidden: true });
    }
  };

  const getFilteredData = () => {
    return Object.entries($searchStore.rawData).reduce((obj, [entityKey, entityData]) => {
      const filteredData = entityData.filter((record) => rowContainsText(record, $searchStore.searchString));
      return { ...obj, [entityKey]: filteredData };
    }, {});
  };

  const loadSearchData = async () => {
    searchRef.querySelector('input')?.select();
    updateKeys({ overlayHidden: false });
    if ($searchStore.loaded || $searchStore.loading) {
      return;
    }
    updateKeys({ loading: true });
    try {
      const [users, groups, organizations] = await Promise.all([getAllUsers(), getGroups(), getOrganizations()]);

      updateKeys({ rawData: { users, groups, organizations }, loading: false, loaded: true });
    } catch (error) {
      console.error('[SearchBar] Failed to retrieve search data!', error);
      updateKeys({ loading: false, error, loaded: true });
    }
  };

  onMount(() => {
    document.addEventListener('click', checkCloseClick);

    return () => {
      document.removeEventListener('click', checkCloseClick);
    };
  });

  $: updateKeys({ filteredData: $searchStore.searchString ? getFilteredData() : $searchStore.rawData });
</script>

<div class="search-bar">
  <div bind:this={searchRef}>
    <HeaderSearch
      disabled={$searchStore.error}
      bind:value={$searchStore.searchString}
      on:focus={loadSearchData}
      on:clear={() => updateKeys({ overlayHidden: true })}
      on:input={() => $searchStore.overlayHidden && updateKeys({ overlayHidden: false })}
    />
  </div>

  <SearchBarOutputWrapper overlayHidden={$searchStore.overlayHidden} />
</div>

<style>
  .search-bar {
    display: contents;
  }

  @media (max-width: 320px) {
    .search-bar {
      display: none;
    }
  }
</style>
